(() => {
  function updateQuestion(form) {
    const link=form.closest('.product-info')?.querySelector('[data-product-question]');
    if(!link)return;
    const config=form.querySelector('[data-stock-config]');
    let title='';try{title=JSON.parse(config.textContent).variants[form.querySelector('[name=id]').value]?.title || '';}catch(_){}
    link.href='https://wa.me/526643871642?text='+encodeURIComponent(link.dataset.chatBase+(title && title!=='Default Title' ? '\n'+link.dataset.sizeLabel+' '+title : ''));
  }
  document.querySelectorAll('.bn-stock-form').forEach(form=>{form.querySelector('[name=id]')?.addEventListener('change',()=>updateQuestion(form));updateQuestion(form);});
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-hat-form]');if(!form)return;
    event.preventDefault();const button=form.querySelector('button[type=submit]'),feedback=form.querySelector('[data-hat-feedback]');
    if(button.disabled)return;const label=button.textContent;button.disabled=true;button.textContent=form.dataset.adding;feedback.textContent='';
    const root=window.Shopify?.routes?.root || '/';
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const result=await response.json();if(!response.ok)throw new Error(result.description || form.dataset.error);
      feedback.textContent=form.dataset.success;
      document.dispatchEvent(new CustomEvent('bn:cart-added'));
      document.dispatchEvent(new CustomEvent('bn:cart-changed'));
      if(location.pathname.replace(/\/$/,'')===root.replace(/\/$/,'')+'/cart'){
        const currentSection=document.querySelector('main .page-wrap')?.closest('[id^=shopify-section-]');
        const sectionId=currentSection?.id.replace('shopify-section-','');
        if(!sectionId){location.assign(root+'cart');return;}
        const fresh=await fetch(root+'cart?section_id='+encodeURIComponent(sectionId),{headers:{Accept:'text/html'},cache:'no-store'});
        if(fresh.ok){const dom=new DOMParser().parseFromString(await fresh.text(),'text/html');const newSection=dom.querySelector('.page-wrap');const oldSection=document.querySelector('main .page-wrap');if(newSection && oldSection){oldSection.replaceWith(newSection);document.dispatchEvent(new CustomEvent('bn:cart-rendered'));}}
      }
    }catch(error){feedback.textContent=error.message || form.dataset.error;}
    finally{button.disabled=false;button.textContent=label;}
  });
})();
